import ApiBack from "../../../../utils/domains/ApiBack";
import Municipio from "../../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import { useForm } from "../../../../utils/hooks/useForm";
import { useRef } from "react";
import Pacts from "../../../../models/Pacts";
import { formatDate } from "../../../../utils/funtions/date";
import { formatCurrency } from "../../../../utils/funtions/format";
import Progress from "../../../../models/Progress";

export const ViewPacProgress = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [arrayProgress, setArrayProgress] = useState<Progress[]>([]);
    const [show, setShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [show2, setShow2] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleCloseData = () => setShowData(false);
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
    //function to error the Token on the time, using when token is invalid or expired
    const [search, setSearch] = useState("");
    const [resumen, setResumen] = useState<any>({});
    const [objPact, setObjPact] = useState<Pacts>();
    const [dateConciliation, setDateCommitment] = useState("");
    const [sattendance, setSattendance] = useState("");
    const [sattendanceBool, setSattendanceBool] = useState(false);

    let { id_pacts, name_creditor, ips_name, programming, date_conciliation, num_certificate, balance, explanation, refund, id_creditor__type_creditor, id_creditor__document_creditor, modality_conciliation, id_ips__municipio_id__codigo_municipio, balance_conciliation } = useParams()
    let { id, date_payment, value_payment, means_payment, pending_payment_value, is_active, doubleLink, object } =
        useForm<Progress>(
            new Progress(
                0,
                0,
                "",
                "",
                "",
                "",
                "",
            ) // Incluye `id_municipio` con un valor inicial
        );


    const cleanBox = (form: HTMLFormElement) => {
        form.reset();

        object.date_payment = "";
        object.value_payment = "";
        object.means_payment = "";
        object.value_payment = "";
        object.pending_payment_value = "";


        form.classList.remove("was-validated");
    };

    // Filtrar los datos según búsqueda
    const filteredIps = arrayProgress.filter((pacts) => {
        if (!search) return true; // si no hay búsqueda, no filtramos nada
        const term = search.toLowerCase().trim();
        return (
            pacts.means_payment.toLowerCase().includes(term)
        );
    });
    const [sortedIps, setSortedIps] = useState(filteredIps);
    const handleTokenError = () => {
        navigate("/");
    };


    const getMunicipality = async () => {
        try {
            const urlGetMunc = ApiBack.MUNICIPIOS_LIST;
            const result = await ServicePrivate.requestGET(urlGetMunc);
            setArrayMunicipio(result);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);
        getMunicipality();

    }

    const getPactConciliation = async () => {
        try {
            const url = ApiBack.VIEW_PROGRESS_BY_PACT + "?id_pacts=" + id_pacts
            const results = await ServicePrivate.requestGET(url);

            if (results) {
                const payload = results.results || [];
                const resumen = results.resumen || {};
                setArrayProgress(payload);
                setResumen(resumen)
            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    2000
                );
                return;
            }

            const formData = {
                id_pacts: id_pacts,
                date_payment: date_payment,
                value_payment: value_payment,
                means_payment: means_payment,
                pending_payment_value: pending_payment_value,

            };

            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_PROGRESS,
                formData
            );
            if (response.status !== 201) {
                setProcess(false);
                MessageToastify(
                    "error",
                    response.error,
                    3000
                );
            } if (response.status === 201) {
                setProcess(false);
                handleClose2();
                cleanBox(form);
                getPactConciliation()
                MessageToastify("success", "Se creó el avance existosamente.", 3000);
            }
        } catch (error) {
            setProcess(false);
            MessageToastify(
                "error",
                "Error en el momento crear el avance por parte del servidor, si el error persiste por favor comuniquese con TI.",
                7000
            );
        }
    };



    useEffect(() => {
        getPactConciliation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (sattendance === "False") {
            setDateCommitment("1800-01-01");
        }
    }, [sattendance])

    function parseAgreement(value: any) {
        if (value === true || value === "true" || value === "1" || value === 1) {
            return "1";        // verdadero
        }

        if (value === false || value === "false" || value === "0" || value === 0) {
            return "2";        // falso
        }

        return "3";            // no aplica
    }

    const getOnePact = async (id: number) => {
        try {
            const urlGetUser = ApiBack.VIEW_PACT_BY_ID + "?id=" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjPact(result[0]);
            console.log(objPact);

            setShowData(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };


    const downloadTXT = () => {
        if (!arrayProgress || arrayProgress.length === 0) {
            MessageToastify('error', 'No hay datos de conciliación para exportar.', 5000);
            return;
        }

        // Convertir cada registro en una línea con |
        const lines = arrayProgress.map(item => {
            return [
                id_creditor__type_creditor,
                id_creditor__document_creditor,
                formatDate(date_conciliation),
                num_certificate,
                date_payment,
                value_payment,
                means_payment,
                pending_payment_value,
            ].join("|");
        });

        // Unir líneas con salto de línea
        const textContent = lines.join("\n");

        // Crear un archivo descargable
        const blob = new Blob([textContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        // Crear link y descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = "conciliaciones.txt";
        link.click();

        // limpiar memoria
        URL.revokeObjectURL(url);
    }
    const MEANS_LABELS: Record<string, string> = {
        "1": "Tesorería",
        "2": "ADRES",
        "3": "Otros mecanismos",
    };

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-4">
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Busqueda de avances
                                        </h4>
                                    </div>
                                    <div className="col-lg-6 col-sm-4">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => downloadTXT()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-file"></i>&nbsp;FT040
                                            </button>
                                            
                                            <button
                                                className={`badge fs-6 py-1 pe-2 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill`}
                                                onClick={() => navigate(-1)}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-backward"></i>&nbsp;Volver
                                            </button>

                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <h4 className="mb-1 fw-bold">Datos del pacto</h4>
                                        </div>

                                        <Row className="g-2 mb-1">
                                            <Col md={12} lg={12}>
                                                <Card className=" border-start" >
                                                    <Card className="border-none ps-2">
                                                        <div className="row mt-1">
                                                            <div className="col-lg-4"><p className="mb-2 text-muted">Nombre Acreedor: <b className="fs-">{name_creditor}</b></p></div>
                                                            <div className="col-lg-4"><p className="mb-2 text-muted">IPS: <b className="fs-">{ips_name}</b></p></div>
                                                            <div className="col-lg-2"><p className="mb-2 text-muted">Número de acta: <b className="fs-">{num_certificate}</b><b className="fs-"><b>
                                                                { }
                                                            </b></b></p></div>
                                                            <div className="col-lg-2"><p className="mb-2 text-muted">Fecha de Conciliación: <b className="fs-">{formatDate(date_conciliation)}</b></p></div>
                                                        </div>
                                                    </Card>
                                                </Card>
                                            </Col>

                                        </Row>

                                        <Row className="g-2">
                                            <Col md={4}>
                                                <Card className="bg-success bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Saldo: <b className="fw-bolder">{formatCurrency(balance)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={4}>
                                                <Card className="bg-primary bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Glosa: <b className="fw-bolder">{formatCurrency(explanation)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={4}>
                                                <Card className="bg-danger bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Devolución: <b className="fw-bolder">{formatCurrency(refund)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>

                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-2 col-md-2">
                                        <p>
                                            Total de pactos:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                    <div className="col-lg-3 col-md-2">
                                        <p>
                                            Total de pactos el la busqueda:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "25%" }}>Fecha pago</th>
                                                <th style={{ width: "10%" }}>Metodo de pago</th>
                                                <th style={{ width: "25%" }}>Valor de pago</th>
                                                <th style={{ width: "15%" }}>Valor pendiente de pago</th>
                                                <th style={{ width: "12%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {(sortedIps.length > 0 ? sortedIps : filteredIps).map((myCreditor, count) => (
                                                <tr key={count + 1}>
                                                    <td>{formatDate(myCreditor.date_payment)}</td>
                                                    <td>{MEANS_LABELS[myCreditor?.means_payment ?? ""] || "No definido"}</td>
                                                    <td>{myCreditor.value_payment}</td>
                                                    <td>{myCreditor.pending_payment_value}</td>

                                                    <td>
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-dark-emphasis bg-dark-subtle border-dark-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-primary-emphasis bg-primary-subtle border-primary-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOnePact(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-a"></i>
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>


                                <Modal
                                    show={showData}
                                    onHide={handleCloseData}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton className="border-bottom-0 pb-2">
                                        <Modal.Title className="text-center fw-bold w-100" style={{ color: "#0f0f70" }}>
                                            Datos pacto
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="pt-1">
                                        <Card className="mt-0 border-0 shadow-none">
                                            <Card.Body className="">

                                                {/* Row 1: Fecha pacto y Asistencia */}
                                                <Card className="bg-primary bg-opacity-10 p-3">
                                                    <Row className="g-4">
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fs-6 fw-light mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-id-card me-2"></i>Fecha pacto
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_pact)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-phone-volume me-2"></i>Fecha de acuerdo
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_agreement)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Fecha compromiso
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_commitment_payment)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fs-6 fw-light mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-calendar me-2"></i>Asistencia
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.attendance}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Número de acta
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.num_certificate}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Acuerdo
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.agreement}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-phone-volume me-2"></i>Tipo de deuda
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0" style={{ whiteSpace: "nowrap" }}>
                                                                    {MEANS_LABELS[objPact?.type_debt ?? ""] || "No definido"}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Card>
                                                <h4 className="mt-1 fw-bolder" style={{ color: "#0f0f70" }}>Información Financiera</h4>

                                                <Card className="bg-success bg-opacity-10 p-3 mt-1">
                                                    <Row className="g-4">
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor pagado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_pact)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Monto a conciliar erp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.reconciliation_amount_erp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Monto a conciliar ebp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.reconciliation_amount_ebp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa aceptada ebp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_acepted_ebp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa subsanada erp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_corrected_erp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa no resulta
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_unresolved)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor conciliado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_reconciled)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor pagado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_payment)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Card.Body>
                                        </Card>
                                    </Modal.Body>
                                    <Modal.Footer className="border-top-0">
                                        <Button variant="danger" onClick={handleCloseData}>
                                            <i className="fa-solid fa-backward me-2"></i>
                                            Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            {/* Campo para nombre_ips */}
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="date_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_payment"
                                                        >
                                                            Fecha del pago:
                                                        </Form.Label>

                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            name="date_payment"
                                                            className="form-control"
                                                            id="date_payment"
                                                            placeholder="Escriba el tipo de acreedor"
                                                            value={date_payment}
                                                            onChange={(e) => {
                                                                doubleLink(e);
                                                                // setDateC(e.target.value);
                                                            }}
                                                            // readOnly={sattendance === "False"}
                                                            autoComplete="off"
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            La fecha del pacto es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-lg-3">

                                                    <Form.Group controlId="means_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="means_payment"
                                                        >
                                                            Metodo de pago:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Select
                                                                required
                                                                id="means_payment"
                                                                name="means_payment"
                                                                value={means_payment}
                                                                onChange={(e) => {
                                                                    doubleLink(e);
                                                                    setSattendance(e.target.value);
                                                                    setSattendanceBool(e.target.value === "True");
                                                                }}
                                                            >
                                                                <option value="">Seleccione la metodo</option>
                                                                <option value="1">Tesorería</option>
                                                                <option value="2">ADRES</option>
                                                                <option value="3">Otros</option>

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                La asistencia es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">

                                                    <Form.Group controlId="value_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_payment"
                                                        >
                                                            Valor pagado:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                id="value_payment"
                                                                name="value_payment"
                                                                placeholder="Escriba el valor pagado"
                                                                value={
                                                                    value_payment
                                                                        ? `COP ${parseInt(value_payment).toLocaleString("es-CO")}`
                                                                        : ""
                                                                }
                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    // Extraer solo números
                                                                    const onlyNumbers = value.replace(/\D/g, "");

                                                                    // Limitar longitud
                                                                    if (onlyNumbers.length <= 15) {
                                                                        const fakeEvent = {
                                                                            ...e,
                                                                            target: {
                                                                                ...e.target,
                                                                                value: onlyNumbers,
                                                                                name: e.target.name,
                                                                            },
                                                                        };

                                                                        doubleLink(fakeEvent);
                                                                    }
                                                                }}
                                                            ></Form.Control>
                                                            <Form.Control.Feedback type="invalid">
                                                                La asistencia es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3"><Form.Group controlId="pending_payment_value" className="mb-3 w-100">
                                                    <Form.Label
                                                        className="fw-bold mb-2 mt-2"
                                                        htmlFor="pending_payment_value"
                                                    >
                                                        Valor pendiente de pago:
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="pending_payment_value"
                                                        className="form-control"
                                                        id="pending_payment_value"
                                                        placeholder="Escriba el valor pendiente"
                                                        value={
                                                            pending_payment_value
                                                                ? `COP ${Number(pending_payment_value || 0).toLocaleString("es-CO")}`
                                                                : ""
                                                        }
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            // Extraer solo números
                                                            const onlyNumbers = value.replace(/\D/g, "");

                                                            // Limitar longitud
                                                            if (onlyNumbers.length <= 15) {
                                                                const fakeEvent = {
                                                                    ...e,
                                                                    target: {
                                                                        ...e.target,
                                                                        value: onlyNumbers,
                                                                        name: e.target.name,
                                                                    },
                                                                };

                                                                doubleLink(fakeEvent);
                                                            }
                                                        }}
                                                        autoComplete="off"
                                                        maxLength={15}
                                                    />
                                                </Form.Group></div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div >
        </>
    );
};
